import { EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { LoadingStatus } from '@mp/shared/domain';

import { ShoppingCart } from '../models';

import { ShoppingCartActions } from './shopping-cart.actions';

export const shoppingCartFeatureKey = 'mpms-core-shopping-cart';

type ShoppingCartsEntityState = EntityState<ShoppingCart>;

export interface ShoppingCartState {
  shoppingCarts: ShoppingCartsEntityState;
  shoppingCartsStatus: LoadingStatus;
}

export const shoppingCartEntityAdapter = createEntityAdapter<ShoppingCart>({
  selectId: (shoppingCart: ShoppingCart) => shoppingCart.shoppingCartId,
});

export const initialState: ShoppingCartState = {
  shoppingCarts: shoppingCartEntityAdapter.getInitialState(),
  shoppingCartsStatus: LoadingStatus.Loaded,
};

export const shoppingCartReducer = createReducer(
  initialState,
  on(
    ShoppingCartActions.fetchShoppingCarts,
    (state): ShoppingCartState => ({
      ...state,
      shoppingCartsStatus: LoadingStatus.Loading,
      shoppingCarts: shoppingCartEntityAdapter.getInitialState(),
    }),
  ),
  on(
    ShoppingCartActions.fetchShoppingCartsSuccess,
    (state, { shoppingCarts }): ShoppingCartState => ({
      ...state,
      shoppingCarts: shoppingCartEntityAdapter.setAll(shoppingCarts, state.shoppingCarts),
      shoppingCartsStatus: LoadingStatus.Loaded,
    }),
  ),
  on(
    ShoppingCartActions.fetchShoppingCartsError,
    (state): ShoppingCartState => ({
      ...state,
      shoppingCartsStatus: LoadingStatus.Error,
      shoppingCarts: shoppingCartEntityAdapter.getInitialState(),
    }),
  ),
  on(
    ShoppingCartActions.shoppingCartUpdate,
    (state, { shoppingCartId, shoppingCart }): ShoppingCartState => ({
      ...state,
      shoppingCarts: shoppingCartEntityAdapter.updateOne(
        { id: shoppingCartId, changes: shoppingCart },
        state.shoppingCarts,
      ),
    }),
  ),
  // remove shopping cart after it is successfully requested
  on(ShoppingCartActions.requestShoppingCartSuccess, (state, { shoppingCartId }) => ({
    ...state,
    shoppingCarts: shoppingCartEntityAdapter.removeOne(shoppingCartId, state.shoppingCarts),
  })),
);

export const { selectAll: selectAllShoppingCarts } = shoppingCartEntityAdapter.getSelectors();
